import script from "./fundHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./fundHistory.vue?vue&type=script&setup=true&lang=ts"

import "./fundHistory.vue?vue&type=style&index=0&id=36bcf2ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bcf2ff"]])

export default __exports__